import { Flex, Text } from '@mantine/core';
import { BetaIcon, BetaText } from '../../../../lib/components';
import SidePanel, {
  SidePanelDetail,
} from '../../../shared/components/NewTable/SidePanel';
import { Supplier } from '../../../shared/types';
import SuppliersPlotTab from './SuppliersPlotsTab';
import SupplierRiskAssessment from './SupplierRiskAssessment';
import SupplierActivitiesTab from './SupplierActivitiesTab';
import { useTranslation } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useToggle } from '@mantine/hooks';
import { useTracking } from '../../../hooks';

const SupplierSidePanel = ({ data = [] }: { data?: Supplier[] }) => {
  const { t } = useTranslation();
  const [copiedId, setCopiedId] = useToggle();
  const { trackEvent } = useTracking();

  const details = [
    {
      label: <BetaText c="gray.6">{t('supplier.labels.commodities')}</BetaText>,
      key: 'plotsCommodities',
      render: (record: Supplier) => (
        <Text truncate w={130}>
          {record.plotsCommodities.join(', ')}
        </Text>
      ),
    },
    {
      label: <BetaText c="gray.6">{t('supplier.labels.status')}</BetaText>,
      key: 'riskAssessment.status',
      render: (record: Supplier) => {
        return <SupplierRiskAssessment supplierId={record.targetBusiness.id} />;
      },
    },
    {
      label: <BetaText c="gray.6">{t('supplier.labels.contact')}</BetaText>,
      key: 'supplierName',
      render: (record: Supplier) => (
        <Text truncate w={300} title={record.supplierName}>
          {record.supplierName}
        </Text>
      ),
    },
    {
      label: <BetaText c="gray.6">{t('admin.business.id')}</BetaText>,
      key: 'businessId',
      span: 12,
      render: (record: Supplier) => {
        return (
          <Flex gap="md">
            <Text>{record.targetBusiness.id}</Text>
            <CopyToClipboard
              text={record.targetBusiness.id || ''}
              onCopy={() => {
                setCopiedId();
                trackEvent('Supplier', {
                  step: 'copy-business-id',
                  action: 'copy',
                });
              }}
              data-testid="client-id-value-copy-button"
            >
              <BetaIcon icon={!copiedId ? 'copy' : 'check'} />
            </CopyToClipboard>
          </Flex>
        );
      },
    },
  ];

  const tabs = [
    {
      label: 'Plots',
      render: (record?: Supplier) => <SuppliersPlotTab {...record} />,
    },
    {
      label: 'Activities',
      render: (record?: Supplier) => <SupplierActivitiesTab {...record} />,
    },
  ];
  return (
    <SidePanel
      titleKey="name"
      details={details as SidePanelDetail<Supplier>[]}
      tabs={tabs}
      data={data}
      selectKey="supplier-id"
    />
  );
};

export default SupplierSidePanel;
